module.exports = __webpack_public_path__ + "static/media/Mp3_Speaker.6a024ebf.svg";